import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.module.less';

// See also StyledDashboardCard.
// Two components that are almost exactly the same, but one
// has images configured as part of the design and one does not.
// These components are styled to match the Dashboard Card used
// by Bevy design in various places throughout the dashbaord
// (Homepage, Event List, E-Mail Upcoming Events, etc.)
export const StyledDashboardCardWithImage = ({ Image, children, imagePosition = 'right' }) => {
  return (
    <article className={classnames(styles.cardWrapper, { [styles[imagePosition]]: imagePosition })}>
      <div className={styles.contentChildren}>{children}</div>
      <Image />
    </article>
  );
};

StyledDashboardCardWithImage.propTypes = {
  Image: PropTypes.func,
  children: PropTypes.node.isRequired,
  imagePosition: PropTypes.oneOf(['top', 'right', 'left']),
};
